import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod/v4'

export const Route = createFileRoute('/_auth/register')({
  validateSearch: z.object({
    email: z.email().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/inscription', search, replace: true })
  },
})
